/** Fundos dos avatares sem foto (ESPEC.md). */
const CORES_AVATAR = [
  '#3B6EA8',
  '#8A5A9E',
  '#2A7D6B',
  '#B5673A',
  '#5E7A2A',
  '#A34B61',
  '#4A5A8C',
];

/** Cor do avatar sem foto: sempre a mesma para a mesma pessoa. */
export function corDoAvatar(id: string): string {
  try {
    return CORES_AVATAR[Number((BigInt(id) >> 22n) % 7n)];
  } catch {
    return CORES_AVATAR[0];
  }
}

/** "Juliana Prado" → "JP"; "dono" → "D". */
export function iniciais(nome: string): string {
  const partes = nome
    .replace(/[^\p{L}\p{N} ]/gu, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!partes.length) return '?';
  const letras =
    partes.length === 1
      ? partes[0].slice(0, 1)
      : partes[0].slice(0, 1) + partes[partes.length - 1].slice(0, 1);
  return letras.toUpperCase();
}

export type StatusVisivel = 'online' | 'idle' | 'dnd' | 'offline';

export function corDoStatus(status: StatusVisivel): string {
  return {
    online: 'var(--cor-online)',
    idle: 'var(--cor-ausente)',
    dnd: 'var(--cor-ocupado)',
    offline: 'var(--cor-apagado)',
  }[status];
}

/** "1 membro", "3 membros": o número com a palavra no singular ou plural. */
export function contar(
  quantidade: number,
  singular: string,
  plural: string,
): string {
  return `${quantidade} ${quantidade === 1 ? singular : plural}`;
}
